import { memo } from "react";
import Screen from "ui/layouts/Screen";
import { ECommercePlatforms } from "ui/organizms/Home";

const ECommercePlatformsScreen = () => (
    <Screen
        title='ECommerce Platforms'
    >
        <ECommercePlatforms />
    </Screen>
);

export default memo(ECommercePlatformsScreen);
